import {Component, Input} from '@angular/core';
import {RuleConfig} from "../../../../model/channels.model";

@Component({
  selector: 'admin-channels-view-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.css']
})
export class AdminChannelsViewRulesComponent {

  @Input() rules?: RuleConfig[];

}
